export const platformServiceTermsCategories = {
  cookies: 'ckie',
  marketing: 'mrkt',
  policy: 'plcy',
  profiling: 'prfl',
} as const;

export const retailerServiceTermsCategories = {
  thirdParty: 'thpr',
} as const;

export const SERVICE_TERMS_CATEGORIES = { ...platformServiceTermsCategories, ...retailerServiceTermsCategories };
